import { gql } from "@apollo/client";

export const getAssetLibraryFileExtensions = gql`
    query getAssetLibraryFileExtensions {
        assetLibraryFileExtensions
    }
`;
